import * as React from "react";
import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16560_1382)">
      <path
        d="M5.93594 0.303711C2.80844 0.303711 0.273438 2.83871 0.273438 5.96621C0.273438 9.09371 2.80844 11.6287 5.93594 11.6287C9.06344 11.6287 11.5984 9.09371 11.5984 5.96621C11.5947 2.83871 9.05969 0.303711 5.93594 0.303711ZM8.73719 8.08121L7.78469 9.03371L5.93594 7.18496L4.08719 9.03371L3.13469 8.08121L4.98344 6.23246L3.13469 4.38371L4.08719 3.43121L5.93594 5.27996L7.78469 3.43121L8.73719 4.38371L6.88844 6.23246L8.73719 8.08121Z"
        fill="#5E6066"
      />
    </g>
    <defs>
      <clipPath id="clip0_16560_1382">
        <rect width={12} height={12} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
